// extracted by mini-css-extract-plugin
export default {"contactBox":"About_contactBox__gEnHW","leftDim":"About_leftDim__sDO5d","rightDim":"About_rightDim__MSNUM","deCenter":"About_deCenter__2EQwr"};